import { render, staticRenderFns } from "./OrgManagement.vue?vue&type=template&id=95a86c06&"
import script from "./OrgManagement.vue?vue&type=script&lang=js&"
export * from "./OrgManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports